import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import CustomCollapse from '../../CustomCollapse'
import LoadingBlock from '../../LoadingBlock'
import CheckIcon from '../../../../assets/icons/check-icon.svg'
import ErrorIcon from '../../../../assets/icons/exclamation-icon.svg'
import FormValidators from '../../../../helpers/FormValidators'
import { DatePicker, TextField, ToggleCheckbox } from '../../FormFields'
import ProductPropertyTypeConstants from '../../../../constants/ProductPropertyTypes'
import { getApplicationPropertiesValidationConfig } from '../../../../helpers/ApplicationPropertiesUtil'

const ApplicationPropertiesForm = ({ formState, disabled }) => {
  // ===== Form state =====
  const { formData, formErrors, onFormDataChanged, validateFormField } = formState

  // ===== Redux state =====
  const productPropertyFormats = useSelector(({ lookupData }) => lookupData?.productPropertyFormats)
  const isFetchingProductPropertyFormats = useSelector(({ lookupData }) => lookupData?.isFetchingProductPropertyFormats)
  
  // ===== Other Variables =====
  const validationConfig = getApplicationPropertiesValidationConfig(productPropertyFormats)

  //  ===== Methods =====
  const onChange = (key, value) => {
    onFormDataChanged(key, value)
    validateFormField(key, value, validationConfig)
  }
   
  const renderLoader = () => {
    return <LoadingBlock message="Loading..." wrapperClass="loading-block-borderless" />
  }

  const getField = (format) => {
    if (!format) return null

    // Set default value
    if (formData[format.propertyKey] === undefined || formData[format.propertyKey] === null) {
      formData[format.propertyKey] = format.defaultValue 
    }  
    
    // Return correct type of field
    switch (format?.type) {
      case ProductPropertyTypeConstants.STRING:
      case ProductPropertyTypeConstants.URL:
      case ProductPropertyTypeConstants.EMAIL:
        return (
          <TextField
            displayName={format.displayName}
            description={format.description}
            onChange={(value) => onChange(format.propertyKey, value)}
            errorMessage={formErrors[format.propertyKey]?.message}
            value={formData[format.propertyKey]}
            disabled={disabled}
          />
        )
      case ProductPropertyTypeConstants.DECIMAL:
      case ProductPropertyTypeConstants.INTEGER:
        return (
          <TextField
            type="number"
            displayName={format.displayName}
            description={format.description}
            onChange={(value) => onChange(format.propertyKey, value)}
            errorMessage={formErrors[format.propertyKey]?.message}
            value={formData[format.propertyKey]}
            disabled={disabled}
          />
        )
      case ProductPropertyTypeConstants.DATE:
        return (
          <DatePicker
            displayName={format.displayName}
            description={format.description}
            onChange={(value) => onChange(format.propertyKey, value)}
            errorMessage={formErrors[format.propertyKey]?.message}
            value={formData[format.propertyKey]}
            disabled={disabled}
          />
        )
      case ProductPropertyTypeConstants.BOOLEAN:
        return (
          <ToggleCheckbox
            displayName={format.displayName}
            description={format.description}
            onChange={(value) => onChange(format.propertyKey, value)}
            errorMessage={formErrors[format.propertyKey]?.message}
            value={formData[format.propertyKey]}
            disabled={disabled}
          />
        )
      default:
        return null
    }
  }

  const renderFields = () => {
    if (!productPropertyFormats || !Array.isArray(productPropertyFormats)) return null

    return productPropertyFormats.map(format => {
      const field = getField(format)
      return <Fragment key={`${format.id}`}>{field}</Fragment>
    })
  }

  return (
    <CustomCollapse
      title="Application Properties"
      description="These are the properties you can set for your application"
      icon={FormValidators.checkFormValidity(formErrors, validationConfig) ? CheckIcon : ErrorIcon}
    >
      <div>
        {isFetchingProductPropertyFormats ? renderLoader() : renderFields()}
      </div>
    </CustomCollapse>
  )
}

export default ApplicationPropertiesForm

